import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCandidateAuth } from '../contexts/CandidateAuthContext';

const CandidateProtectedRoute = ({ children, requiredPermissions = [] }) => {
  const { isAuthenticated, loading, user } = useCandidateAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check permissions if required
  /* if (requiredPermissions.length > 0) {
    const hasRequiredPermissions = hasAllPermissions(requiredPermissions);
    
    if (!hasRequiredPermissions) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-red-600 mb-2">Access Denied</h1>
            <p className="text-gray-400">You don't have permission to access this page.</p>
          </div>
        </div>
      );
    }
  }

  // Check if user is superadmin
  if (user?.user?.role !== 'superadmin') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-2">Access Restricted</h1>
          <p className="text-gray-400">This portal is for super administrators only.</p>
        </div>
      </div>
    );
  } */

  return children;
};

export default CandidateProtectedRoute;